import { FetchBaseQueryError } from '@reduxjs/toolkit/query'

import { screenshotsChangedError } from '../../../api/analysis-screenshots'
import { ConceptsReadBack, ScreenshotsReadBack } from '../types/AnalysisScreenshots'

export type Message = { key: string; options?: Record<string, unknown> }

type Positions = (ids: string[]) => string

// What a list write's read-back doesn't show, or nothing when it shows everything sent.
export const getScreenshotsReadBackProblems = (
  { missingIds, unexpectedIds, orderChanged, changedIds }: ScreenshotsReadBack,
  positions: Positions
): Message[] => {
  const messages: Message[] = []
  if (missingIds.length) messages.push({ key: 'internal-analysts:analysis_screenshots_readback_missing', options: { count: missingIds.length } })
  if (unexpectedIds.length) messages.push({ key: 'internal-analysts:analysis_screenshots_readback_unexpected', options: { count: unexpectedIds.length } })
  if (orderChanged) messages.push({ key: 'internal-analysts:analysis_screenshots_readback_order' })
  if (changedIds.length) {
    messages.push({ key: 'internal-analysts:analysis_screenshots_readback_changed', options: { count: changedIds.length, positions: positions(changedIds) } })
  }
  return messages
}

export const getConceptsReadBackProblem = ({ notStored }: ConceptsReadBack, positions: Positions, matched: boolean): Message | undefined => {
  const ids = Object.keys(notStored)
  if (!ids.length) return undefined
  return {
    key: matched ? 'internal-analysts:analysis_screenshots_readback_not_matched' : 'internal-analysts:analysis_screenshots_readback_not_unmatched',
    options: { count: ids.length, positions: positions(ids) },
  }
}

export const isScreenshotsChangedError = (error: unknown) => {
  const fetchError = error as (FetchBaseQueryError & { error?: string }) | undefined
  return fetchError?.status === 'CUSTOM_ERROR' && fetchError.error === screenshotsChangedError
}

// 1-based positions in `ids`, for messages.
export const toPositions =
  (ids: string[]): Positions =>
  (wanted) =>
    wanted
      .map((id) => ids.indexOf(id))
      .filter((index) => index >= 0)
      .map((index) => index + 1)
      .sort((a, b) => a - b)
      .join(', ') || '-'
